export default __webpack_public_path__ + "static/media/030_corner1.first.39a45972.webp";